<div>
  <table
      mat-table
      [dataSource]="surveys$ | async"
      matSort
      matSortActive="customStatus"
      matSortDirection="asc"
      matSortDisableClear="true"
      style="margin: 0;"
  >
    <ng-container matColumnDef="title">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate>Titolo</span>
      </mat-header-cell>
      <mat-cell *matCellDef="let data"> {{data.title}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="points">
      <mat-header-cell
          class="cell-small cell-align-center"
          *matHeaderCellDef mat-sort-header>
        <span>Punti</span>
      </mat-header-cell>
      <mat-cell
          class="cell-small cell-align-center"
          *matCellDef="let data"> {{data.points}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="customStatus">
      <mat-header-cell
          class="cell-small cell-align-center cell-actions"
          *matHeaderCellDef mat-sort-header>
        <span translate >Stato</span>
      </mat-header-cell>
      <mat-cell
          class="cell-small cell-align-center cell-actions"
          *matCellDef="let data"
          [ngSwitch]="!!data?.completed"
          style="text-align: left; white-space: nowrap"
      >
        <span *ngSwitchCase="false">
          <ng-container *ngIf="configuration$ | async as configuration">
            <!-- Survey available -->
            <span *ngIf="configuration.limesurveyUrl && data.active !== false" >
              <a
                  [routerLink]="['/dashboard', 'participant', 'survey', data.limesurvey_id]"
                  [queryParams]="{token: data.token}"
                  class="btn btn-primary btn-pollstar-small"
                  style="color: white;"
              >
                <span class="desktop" style="font-size:1rem;">
                  <span class="status-link__text">Rispondi</span>
                </span>
                <span class="mobile"><i class="fas fa-chevron-right"></i></span>
              </a>
            </span>
          </ng-container>

          <!-- Survey closed/expired -->
          <span *ngIf="data.active === false">
            <span>Chiuso</span>
          </span>
        </span>

        <!-- Survey Completed by user -->
        <span *ngSwitchDefault class="text-success"><span>Completato</span></span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
        *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{
                  'survey-not-completed': !row?.completed && row?.active !== false,
                  'survey-expired': row?.active === false && row?.completed === false
                }"
    ></mat-row>
  </table>
</div>

<mat-paginator
    [pageSizeOptions]="[pageSize]"
    [hidePageSize]="true"
    showFirstLastButtons
></mat-paginator>

<!--Initial survey overlay          -->
<ng-container *ngIf="!(hasCompletedInitialSurvey$ | async) && !(isSyncInProgress$ | async)">
  <div class="card-body" *ngIf="initialSurvey$ | async as initialSurvey">
    <app-card-overlay>
      <i class="fas fa-lock fa-4x" style="margin:2rem 0 1rem 0;"></i>
      <br>
      <h3>Rispondi al sondaggio di benvenuto</h3>
      <h6 style="margin:0.8rem 0 0 0; font-weight: bold; text-align: center; line-height: 2rem;">
        <p>Avrai accesso a nuovi sondaggi dopo averlo completato</p>
        <br>
        <p
            class="pointer"
            [routerLink]="['/dashboard', 'participant', 'survey', initialSurvey.limesurvey_id]"
            [queryParams]="{token: initialSurvey.token}"
        >
          <strong style=" text-decoration: underline;">Clicca qui per procedere</strong>
        </p>
      </h6>
    </app-card-overlay>
  </div>
</ng-container>

<ng-container *ngIf="(isSyncInProgress$ | async)">
  <app-card-overlay title="Ricerca nuovi sondaggi in corso" ></app-card-overlay>
</ng-container>
